export default {
      id: "icon-unlink-usage",
      viewBox: "-2 -4 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-unlink",
      toString: function () {
        return this.url;
      }
    }